import { render, staticRenderFns } from "./ot-select.vue?vue&type=template&id=25e156ba&scoped=true&"
import script from "./ot-select.vue?vue&type=script&lang=ts&"
export * from "./ot-select.vue?vue&type=script&lang=ts&"
import style0 from "./ot-select.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ot-select.vue?vue&type=style&index=1&id=25e156ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e156ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
